export default class InvalidEstadoError extends Error {
    constructor(estado){
        super(`La oportunidad esta "${estado}"`);
        this.estado = estado;
        this.type = "InvalidEstadoError";
        this.info = `Las oportunidades con el estado "${estado}" no se les puede crear facturas Forecast`;
    }
}